import { useNavigate } from "react-router-dom";
import { Terminal, GraduationCap, Briefcase, Activity, ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import TopNav from "@/components/TopNav";

export default function StudentHome() {
  const { user } = useAuth();
  const nav = useNavigate();
  const first = (user?.name || user?.email || "coder").split(/[ @]/)[0];
  const firstCap = first.charAt(0).toUpperCase() + first.slice(1);

  return (
    <div className="min-h-screen">
      <TopNav />
      <main className="max-w-6xl mx-auto px-4 sm:px-8 pt-10 pb-24">
        <div className="fade-up">
          <span className="pill text-[11px] tracking-[0.2em] px-4 py-1.5 glass text-teal-accent inline-block">
            PREMIUM CODING STUDIO
          </span>
          <h1 className="serif text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-6 leading-tight">
            Good to see you, <span className="text-teal-accent glow-text">{firstCap}</span>.
          </h1>
          <p className="text-muted-foreground mt-4 max-w-xl text-base">
            Practise real coding in a VS Code-style studio, or level up with 90-day certificate
            courses. When you're ready, unlock the career board.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mt-12">
          <ActionCard testid="home-coding" icon={Terminal} title="Coding"
                      desc="Build multi-file projects with a live editor, terminal, AI assistant and instant preview."
                      cta="Open the editor" onClick={() => nav("/coding")} big />
          <ActionCard testid="home-courses" icon={GraduationCap} title="Courses"
                      desc="Ten professional 90-day certificate tracks — from Full Stack to Generative AI."
                      cta="Browse courses" onClick={() => nav("/courses")} big />
        </div>
        <div className="grid md:grid-cols-2 gap-6 mt-6">
          <ActionCard testid="home-jobs" icon={Briefcase} title="Jobs"
                      desc="Internships and placements, unlocked once you complete your first course."
                      cta="Explore job vacancies" onClick={() => nav("/jobs")} big />
          <ActionCard testid="home-activity" icon={Activity} title="Activity"
                      desc="Track your enrolled courses, progress and completion at a glance."
                      cta="View my activity" onClick={() => nav("/activity")} big />
        </div>
      </main>
    </div>
  );
}

function ActionCard({ icon: Icon, title, desc, cta, onClick, testid, big }) {
  return (
    <button data-testid={testid} onClick={onClick}
            className={`glass glass-hover rounded-3xl p-8 text-left w-full group ${big ? "" : "flex md:items-center gap-6 flex-col md:flex-row"}`}>
      <div className={big ? "" : "flex items-center gap-6 flex-1"}>
        <div className="w-14 h-14 rounded-2xl bg-[#00D4D4]/12 flex items-center justify-center mb-5 md:mb-0 group-hover:shadow-[0_0_24px_rgba(0,212,212,0.4)] transition-shadow shrink-0">
          <Icon size={26} className="text-teal-accent" />
        </div>
        <div className={big ? "" : ""}>
          <h2 className="serif text-2xl md:text-3xl font-bold">{title}</h2>
          <p className="text-muted-foreground text-sm mt-2 max-w-md">{desc}</p>
        </div>
      </div>
      <span className={`inline-flex items-center gap-2 text-teal-accent text-sm font-medium mt-6 md:mt-6 group-hover:gap-3 transition-all ${big ? "" : "md:mt-0"}`}>
        {cta} <ArrowRight size={16} />
      </span>
    </button>
  );
}
